// extracted by mini-css-extract-plugin
module.exports =  {"opacity":"DZQCV2MEWUiRK7cI3sfj","opacityTitle":"PkwHREwZnkwUSYojxD1J","opacityBtn":"LeUORXeZuc1WxnWhTCFq"};